/* eslint-disable react/no-unknown-property */
import React, { useRef, useEffect } from 'react';
import { useGLTF, Center } from '@react-three/drei';
import * as THREE from 'three';

const GenericModel = ({
    url,
    scale = { x: 1, y: 1, z: 1 },
    rotation = { x: 0, y: 0, z: 0 },
    position = { x: 0, y: 0, z: 0 },
    materialConfig
}) => {
    const { scene } = useGLTF(url);
    const modelRef = useRef();

    useEffect(() => {
        if (scene) {
            scene.traverse((child) => {
                if (child.isMesh) {
                    child.castShadow = true;
                    child.receiveShadow = true;

                    // Material Override Logic
                    if (materialConfig) {
                        try {
                            if (!child.material.isCloned) {
                                child.material = child.material.clone();
                                child.material.isCloned = true;
                            }
                            if (materialConfig.color && materialConfig.color !== '#ffffff') {
                                child.material.color = new THREE.Color(materialConfig.color);
                            }
                            if (materialConfig.metalness !== undefined) {
                                child.material.metalness = materialConfig.metalness;
                            }
                            if (materialConfig.roughness !== undefined) {
                                child.material.roughness = materialConfig.roughness;
                            }
                        } catch (err) {
                            console.warn("Failed to apply material config", err);
                        }
                    }
                }
            });
        }
    }, [scene, materialConfig, url]);

    // Construct vectors from props to ensure safe usage
    const scaleVec = [scale?.x || 1, scale?.y || 1, scale?.z || 1];
    const posVec = [position?.x || 0, position?.y || 0, position?.z || 0];
    const rotVec = [rotation?.x || 0, rotation?.y || 0, rotation?.z || 0];

    return (
        <group
            position={posVec}
            rotation={rotVec}
            scale={scaleVec}
        >
            {/* Axes Helper removed for production */}

            {/* Center automatically calculates bounding box and centers the object at LOCAL (0,0,0) */}
            <Center top>
                <primitive object={scene} ref={modelRef} />
            </Center>
        </group>
    );
};

export default GenericModel;
